import type { EmbeddingsInputs } from "../../../services/api/instances/embeddingsApi/types";

export const checkEmptyValue = (values: EmbeddingsInputs[]) => {
  const checkValue = values?.find((v) => v.value === "");
  return !!checkValue;
};